import { createContext, useContext } from 'react';
import defaultConfig from '../config/timing.json';

// Context + hook, losgetrokken van TrackConfigProvider zodat het provider-bestand
// alleen componenten exporteert (Vite fast refresh).
export const TrackConfigContext = createContext(defaultConfig);

export function useTrackConfig() {
  return useContext(TrackConfigContext);
}
